const Place = {

    // FIELDS
    "name": "Name",
    "pin": "PIN",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "place": "Place",

    // ERROR
    "error_pin": "Select PIN",
    "error_status": "Select Status",
    "error_name": "Enter Name",

    // TABLE HEADER
    "table_name": "NAME",
    "table_pin": 'PINCODE',
    "table_status": 'STATUS',

}

export default Place;